// FILE: /src/Components/BuySubscription/UpgradeModal.js (NEW FILE)

import React from 'react';
import { Modal, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import {
  ArrowRightOutlined,
  LockOutlined,
} from '@ant-design/icons';

const UpgradeModal = ({
  isOpen,
  onClose,
  featureName,
  message,
}) => {
  const navigate = useNavigate();
  const resolvedFeatureName =
    String(featureName || '').trim() || 'this feature';

  const handleUpgrade = () => {
    onClose();
    navigate('/select-plan');
  };

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      centered
      width={480}
      className="upgrade-modal"
      rootClassName="upgrade-modal-root"
      destroyOnClose
    >
      <div className="upgrade-modal-content">
        <div className="upgrade-modal-icon" aria-hidden="true">
          <LockOutlined />
        </div>

        <div className="upgrade-modal-copy">
          <span className="upgrade-modal-eyebrow">
            Plan upgrade required
          </span>

          <h2>
            {`Unlock ${resolvedFeatureName}`}
          </h2>

          <p>
            {message ||
              'This feature is not included in your current plan. Choose a plan that includes it to continue.'}
          </p>
        </div>

        

        <div className="upgrade-modal-actions">
          <Button
            onClick={onClose}
            className="upgrade-modal-secondary-button"
          >
            Not now
          </Button>

          <Button
            type="primary"
            icon={<ArrowRightOutlined />}
            iconPosition="end"
            onClick={handleUpgrade}
            className="upgrade-modal-primary-button"
          >
            View plans
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default UpgradeModal;